import Error404Component from "../../../components/shared/error-components/404-error-component";

function Error404() {
  return <Error404Component />;
}

export default Error404;
